"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const EsriLeafletLayer_1 = require("./EsriLeafletLayer");
/**
 * DynamicMapLayer component, react-leaflet wrapper for [L.esri.DynamicMapLayer](https://developers.arcgis.com/esri-leaflet/api-reference/layers/dynamic-map-layer/).
 *
 * For more info: https://github.com/slutske22/react-esri-leaflet#components
 */
const DynamicMapLayer = React.forwardRef((props, ref) => (React.createElement(EsriLeafletLayer_1.default, { ref: ref, layerType: "dynamicMapLayer", ...props })));
exports.default = DynamicMapLayer;
